import { createFetch } from "@vueuse/core";

import globalStore from "@/core/store/globalStore";
import { User } from "@/domain/user";

const URL = import.meta.env.VITE_NEW_TEST_URL;

export const useScheduleFetch = createFetch({
	baseUrl: URL,
	fetchOptions: {
		mode: "cors",
	},
	options: {
		beforeFetch: async ({ options, cancel }) => {
			const token = globalStore.getters.getToken;
			const { id } = globalStore.getters.getCurrentUserInfo as User;

			if (!token || !id) {
				cancel();
			}

			options.headers = {
				...options.headers,
				Authorization: `Token ${token}`,
				id: id.toString(),
			};

			return { options };
		},
	},
});
